// libs
import classNames from 'classnames'
import * as React from 'react'

// components
import Icon from 'src/components/forms/icon/icon'

// helpers
import Logo from 'src/components/logo/logo'
import { textResources } from 'src/lang/de'
import { createBemBlock } from 'src/utils/bem_helper/bem_helper'
import { scrollTop } from 'src/utils/wizard'
import { authStepsList } from '../../authentication/auth.utils'
import './wizard_step.scss'

const cls = createBemBlock('wizard-step')

export interface IProps {
  headerText?: string | JSX.Element;
  leftButton?: JSX.Element;
  rightButton?: JSX.Element;
  rightButtonFn?: () => Promise<void> | void;
  contentCls?: string;
  layout: WizardLayout;
  alignLeft?: boolean;
  spacing?: boolean;
  showHeaderText?: boolean;
  isValid?: boolean;
  progressBar?: any;
  activeStep?: string;
}

export const WIZARD_LAYOUT_MODAL = 'modal'
export const WIZARD_LAYOUT_PAGE = 'page'
type WizardLayout = typeof WIZARD_LAYOUT_MODAL | typeof WIZARD_LAYOUT_PAGE;

export default class WizardStep extends React.PureComponent<IProps, {}> {
  componentDidMount () {
    if (this.props.layout === WIZARD_LAYOUT_PAGE) {
      scrollTop()
    }
  }

  public render () {
    const {
      activeStep, progressBar, leftButton, rightButton, children, headerText, showHeaderText,
      contentCls, alignLeft, spacing = true, rightButtonFn, isValid
    } = this.props

    const handleRightButtonClick = () => {
      if (!isValid) return
      if (rightButtonFn) {
        rightButtonFn()
      }
    }

    return (
      <div className={cls()}>

        {showHeaderText && (
          <div className={cls('header')}>
            <h2 className={classNames(cls('header-text'), cls('header-text', alignLeft ? 'left' : ''))}>{headerText}</h2>
          </div>
        )}

        <div className={cls('progress_bar')}>{progressBar}</div>

        <div className={cls('content')}>
          {activeStep && <p className="step-name">Schritt: {authStepsList[activeStep]}</p>}

          {children}

          <div className={cls('footer')}>
            {leftButton && <span className="button_back">{leftButton}</span>}

            <span className="button_right">
              {rightButton && rightButton}
            </span>

            {!!rightButtonFn && (
              <span className="button_right">
                <button className="lp_wizard-button" disabled={!isValid} onClick={handleRightButtonClick}>
                  Weiter
                </button>
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
}
